import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

const FullPageFrame = ({ title, slug }) => {
  const siteData = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteSRC
        }
      }
    }
  `)

  const sourceURL = siteData.site.siteMetadata.siteSRC
  const StyledIframe = styled.iframe`
    height: 100%;
    width: 100vw;
    inset: 0;
    border: none;
    position: fixed;
    top: 0;
    margin-bottom: 40px;
  `

  return (
    <>
      <StyledIframe src={`${sourceURL}/${slug}`} title={title} />
    </>
  )
}

export default FullPageFrame
